import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Cliente ID' }),
        vc_url_dashboard: new EntityColumn<string>({ name: 'vc_url_dashboard', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'URL Dashboard Clientes' }),
        vc_workspace_id: new EntityColumn<string>({ name: 'vc_workspace_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Workspace Id' }),
        vc_report_id: new EntityColumn<string>({ name: 'vc_report_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Report Id' }),
        vc_token: new EntityColumn<string>({ name: 'vc_token', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Token' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
       
    }
)

const clientActions = () =>
(
    {

    }
)

export class DashboardClientesDef extends EntityDefinition {

    columns = columns();
    views = views();
    clientActions = clientActions();

    constructor() {
        super('DashboardClientes');
    }
}